/**
 * Normalize entity values for display / expand UI.
 * Live orchestrator often returns objects/arrays; String(obj) becomes "[object Object]".
 */
export function serializeEntityValue(value: unknown): string | null {
  if (value == null) return null;
  if (typeof value === 'string') {
    const t = value.trim();
    return t.length > 0 ? t : null;
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  try {
    return JSON.stringify(value);
  } catch {
    const fallback = String(value);
    return fallback.trim().length > 0 ? fallback : null;
  }
}

export function entityValueIsFilled(value: unknown): boolean {
  return serializeEntityValue(value) != null;
}
